<template>
  <v-container fluid>
    <v-row>
      <v-col :cols="edit ? 8 : 12">
        <v-card height="500">
          <v-sheet v-if="loading" class="mt-2 d-flex align-center justify-center" rounded="" height="500" color="#eee">
            <v-progress-circular
              class=""
              indeterminate
              color="primary"
            />
          </v-sheet>
          <div v-else>
            <v-card-title>
              Kosten
              <v-spacer />
              <v-btn @click="edit = !edit">
                Bearbeiten
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-divider />
              <line-chart :chart-data="chartData" />
            </v-card-text>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="edit" :cols="edit ? 4 : 0">
        <v-card height="500">
          <v-card-title>
            Zusätzliche Kosten
          </v-card-title>
          <v-card-text>
            <v-col>
              <v-text-field v-model="additionalCost.serverCost" label="Serverkosten" />
              <v-text-field v-model="additionalCost.personal" label="Personal Kosten" />
              <v-text-field v-model="additionalCost.divers" label="Sonstiges" />
            </v-col>
            <v-col class="d-flex justify-end">
              <v-btn @click="updateAdditionalCosts">
                Speichern
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
   data () {
      return {
         edit: false,
         loading: true,
         additionalCost: {
            serverCost: null,
            divers: null,
            personal: null
         },
         chartData: {
            labels: [],
            datasets: [

            ]
         },
      }
   },
   mounted () {
      this.loadData()
   },
   methods: {
      updateAdditionalCosts () {
         this.edit = false
         axios.patch(this.route('api.statistic.save'), this.additionalCost)
      },
      loadData () {
         const turnoverDataset = {
            label: 'Einmalige Vertragskosten',
            backgroundColor: '#e51f85',
            borderColor: '#e51f85',
            data: []
         }
         const runningCostDataset = {
            label: 'Monatliche Vertragskosten',
            backgroundColor: '#ffa500',
            borderColor: '#ffa500',
            data: []
         }
         const staticCostDataset = {
            label: 'Fix Kosten',
            backgroundColor: '#10498A',
            borderColor: '#10498A',
            data: []
         }

         const fullCostDataSet = {
            label: 'Gesammt Kosten',
            backgroundColor: '#e31e24',
            borderColor: '#e31e24',
            data: []
         }
         axios.get(this.route('cost.statistic.index')).then((response) => {
            for (const [key, value] of Object.entries(response.data.turnover)) {
               this.chartData.labels.push(key)
               turnoverDataset.data.push(value)
            }
            this.chartData.datasets.push(turnoverDataset)

            for (const value of Object.entries(response.data.running_cost)) {
               runningCostDataset.data.push(value)
            }
            this.chartData.datasets.push(runningCostDataset)

            for (const value of Object.entries(response.data.staticCost)) {
               staticCostDataset.data.push(value)
            }
            this.chartData.datasets.push(staticCostDataset)

            for (const value of Object.entries(response.data.fullcost)) {
               fullCostDataSet.data.push(value)
            }
            this.chartData.datasets.push(fullCostDataSet)

            this.startDate = response.data.startDate
            this.endDate = response.data.endDate

            this.loading = false
         })
      }
   }
}
</script>

<style>

</style>
